import { useCallback } from 'react';

/**
 * Custom hook to open a URL in the default browser or in Electron's shell.
 *
 * If the application is running in Electron, it will send the `open-url` event
 * to the main process via `window.electron`. Otherwise, it will use `window.open`.
 *
 * @param url - The URL to be opened.
 * @returns A memoized callback function to open the specified URL.
 */

export const useOpenBrowser = (url?: string | null) => {
  return useCallback(() => {
    if (!url) return;

    if (window.electron) {
      window.electron.send('open-url', url);
    } else {
      window.open(url, '_blank');
    }
  }, [url]);
};
